

 var App = {
  init: function() {
    App.setupEvents();
    App.hiddenColumn();
  },

  setupEvents: function() {
    (function($, window) {
      $.fn.replaceOptions = function(options, attr) {
        var self, $option;
        var prompt = this.find("option[value='']");
        this.empty();
        if (prompt && prompt.length) {
          this.append(prompt[0]);
        }
        self = this;
        $.each(options, function(index, option) {
          $option = $('<option></option>')
          .attr('value', option.id)
          .text(option.title);

          if (attr) {
            $option.attr(attr, option[attr]);
          }

          self.append($option);
        });
      };

      $.fn.serializeObject = function(){
        var results = {},
            arr = this.serializeArray();
        for (var i = 0, len = arr.length; i < len; i++) {
          obj = arr[i];
          if (results.hasOwnProperty(obj.name)) {
            if (!results[obj.name].push) {
              results[obj.name] = [results[obj.name]];
            }
            results[obj.name].push(obj.value || '');
          } else {
            results[obj.name] = obj.value || '';
          }
        }
        return results;
    }

      if ($('.search-filter-input').length) {
        $('.search_filter_form input').on('change', function() {
          $('.search-filter-input').val($(this).val());
        });

        $(document).on("submit", ".search_filter_form", function(e){
          e.preventDefault();
          $('#form-filter').submit();
          return  false;
        });
      }

      $('#print-content').on('click', function() {
        window.print();
      });

      $('.app-logout-form').on('submit', function() {
        try {
          if (window.$crisp) window.$crisp.push(["do", "session:reset", [true]]);
        } catch (error) {
          // Chat cleanup is best-effort; the browser must still submit logout.
        }
        try {
          if (window.cioanalytics && typeof window.cioanalytics.reset === "function") window.cioanalytics.reset();
        } catch (error) {
          // Limpar o Customer.io é melhor esforço; o logout precisa seguir.
        }
      });

      $('.dropdown-item.disabled').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
      });

      // The navbar search and fullscreen toggles are <a href="#"> anchors and the theme
      // handlers (core/app.js) never prevent the default, so clicking them cleared the
      // URL hash. On the tariffs page that hash is the router, so opening the search on
      // #offers bounced the page back to the calendar.
      $(document).on('click', '.nav-link-search, .nav-link-expand', function(e) {
        e.preventDefault();
      });

    })(jQuery, window);
  },

  orderColumn: function(param, direction) {
    var link;
    var column =  $('#header-'+param);
    if (!column.length) return;
    if (direction === 'asc') {
      link = column.attr('href').replace("direction=asc", "direction=desc");
    } else {
      link = column.attr('href').replace("direction=desc", "direction=asc");
    }
    column.children('i').removeClass('fa-sort').addClass('fa-sort-alpha-'+direction);
    column.attr('href',link);
  },

  hiddenColumn: function() {
    $('.change-column').change(function(){
      var lnk = $('#table-list').data('link-path');
      var url = $('body').data('link')+'?';

      var fields = lnk.replace(url, '&').split('&');
      var field = $(this).val();
      var column = '.';

      if (field === 'phone') column += 'primary_phone';
      else column += field;

      if ($(this).is(':checked')) {
        if ($.inArray(field === -1)) { fields.push('fieldset%5B%5D=' + field); }
        $(column).removeClass('hidden-column');
      } else {
        if ($.inArray(field !== -1)) { fields.splice( $.inArray('fieldset%5B%5D=' + field, fields), 1 ); }
        $(column).addClass('hidden-column');
      }

      for(var i=0; i<=fields.length; i++) {
        if (fields[i] !== '' && typeof fields[i] !== 'undefined') {
          url += fields[i] + '&';
        }
      }

      if (url.slice(-1) === '&') { url = url.slice(0,-1); }

      $('#table-list').data('link-path', url);

      App.linksOrder(url);
      App.linksPaginate(url);
      App.linkFilter(url);
    });
  },

  linksOrder: function(url) {
    $('.order-column').attr('href',url);
  },

  linkFilter:function(url){
    $("#filters").html("");
    $("#filters-search").html("");
    fieldsets = url.split('&fieldset%5B%5D=');
    for (i = 1; i < fieldsets.length; i++) {
      field = '<input type="hidden" name="fieldset[]" value="'+fieldsets[i]+'"/>'
      $('#filters').append(field);
      $("#filters-search").append(field)
    }
    last_field = '<input type="hidden" name="fieldset[]" value="'+fieldsets[0].split("=")[1]+'"/>'
    $('#filters').append(last_field);
    $("#filters-search").append(last_field);
  },

  linksPaginate: function(url) {
    // Change URL buttons
    $('.pagination .page-item .page-link').each(function () {
      var old_url = $(this).attr('href');
      if (typeof old_url !== 'undefined') {
        var page = old_url.substr(old_url.length - 1);

        // Insert param page
        if (/^[0-9]$/.test(page)) { url += '&page=' + page; }

        // Change URL
        $(this).attr('href', url);
      }
    });
  },

  formChangeValidatePicture: function(field) {
    if ($('#'+field).length) {
      $('#'+field).hide();
      $('.'+field).html($('#'+field).html());
    } else {
      $('.'+field).html('');
    }
  }
};

// O prefixo vem do <meta name="account-path"> que o layout escreve (a home pode ser servida no `/`,
// sem o slug no caminho). Sem a meta, como nos layouts que não a escrevem, vale o primeiro
// segmento do caminho, como sempre.
function accountSlugUrl(url) {
  var meta = document.querySelector('meta[name="account-path"]');
  var prefix = meta ? meta.getAttribute("content") : "/" + window.location.pathname.split("/")[1];
  return prefix + url;
}

// Versão do cache do navegador, do <meta name="account-cache-version"> do layout (INFRA-314). As
// listas com `max-age` (categorias de transação, itens) vão com ela em `?v=`: sem isso, a categoria
// criada em Ajustes não aparece nem recarregando a página até o TTL vencer. Par do
// `deprecated/utils/cache-version.js`.
function accountCacheVersion() {
  var meta = document.querySelector('meta[name="account-cache-version"]');
  return meta ? meta.getAttribute("content") : "";
}

$(document).ready(function() {
  App.init();
});
